/**
 * Insights: cursor glow on the lead image — same vanilla JS pattern as SolutionsMatrix.
 */
(function () {
    'use strict';

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.addEventListener('DOMContentLoaded', function () {
        var leads = document.querySelectorAll('.mnhq-insights__lead');
        leads.forEach(function (lead) {
            lead.addEventListener('mousemove', function (e) {
                var r = lead.getBoundingClientRect();
                var mx = ((e.clientX - r.left) / r.width) * 100;
                var my = ((e.clientY - r.top) / r.height) * 100;
                lead.style.setProperty('--mx', mx + '%');
                lead.style.setProperty('--my', my + '%');
            });
        });
    });
})();
